import { QueryClient } from '@tanstack/react-query';
import { isApiError } from '@/lib/errors';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Do not retry on 4xx from our backend.
        if (isApiError(error) && error.status >= 400 && error.status < 500) {
          return false;
        }
        return failureCount < 1;
      }
    },
    mutations: {
      retry: false
    }
  }
});
